import { onBeforeUnmount, onMounted } from "vue"
import { onBeforeRouteLeave } from "vue-router"

export function useVideoProgress(options: {
	type: string
	id: number
	onComputeAndStore?: (args: { currentTime: number; playerDuration: number }) => void | Promise<void>
	getPlayer: () => any | null
}) {
	let alreadyDisposed = false
	// Save current progress
	const saveProgress = async () => {
		try {
			const player = options.getPlayer?.()
			if (!player || typeof player.currentTime !== "function") return

			const currentTime = player.currentTime()
			if (currentTime && currentTime > 1) {
				let duration = 0
				try {
					duration = typeof player.duration === "function" ? player.duration() : 0
				} catch {}

				if (options.onComputeAndStore) {
					await options.onComputeAndStore({ currentTime, playerDuration: duration })
				}
			}

			// Reset if ended
			try {
				if (typeof player.ended === "function" && player.ended()) {
				}
			} catch {}
		} catch (e) {
			console.warn("saveProgress failed", e)
		}
	}

	// Dispose player
	const disposePlayer = () => {
		if (alreadyDisposed) return
		try {
			const player = options.getPlayer?.()
			if (player && typeof player.dispose === "function") {
				player.dispose()
			}
		} catch {}
		alreadyDisposed = true
	}

	// Save and optionally navigate back
	const saveAndDispose = async (navigateBack?: () => void) => {
		await saveProgress()
		// disposePlayer()
		if (navigateBack) navigateBack()
	}

	// Handle unload / visibility
	const handleBeforeUnload = () => saveAndDispose()
	const handleVisibilityChange = () => {
		if (document.hidden) saveAndDispose()
	}

	onMounted(() => {
		window.addEventListener("beforeunload", handleBeforeUnload)
		document.addEventListener("visibilitychange", handleVisibilityChange)
	})

	onBeforeUnmount(() => {
		saveAndDispose()
		window.removeEventListener("beforeunload", handleBeforeUnload)
		document.removeEventListener("visibilitychange", handleVisibilityChange)
	})

	onBeforeRouteLeave(() => {
		saveAndDispose()
	})

	return {
		saveProgress,
		saveAndDispose,
		disposePlayer,
	}
}
